import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/icon_6.png'
import _imports_1 from '@/assets/icon_7.png'


const _hoisted_1 = {
  key: 0,
  class: "fixed ab-right flex-column-center-center z-100"
}
const _hoisted_2 = { class: "no_rem_menu no_rem_mr-30 flex-column-sb-center relative z-100" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "no_rem_menu_icon",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  class: "no_rem_menu_icon",
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex-row-center-center no_rem_pt-14 font-blod color-white no_rem_title" }, "番顺茶业", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "flex-row-center-center no_rem_mt-4 color-white no_rem_desc" }, "优质普洱茶挖掘者", -1)
const _hoisted_9 = { class: "flex-row-center-center no_rem_mt-38" }
const _hoisted_10 = { class: "no_rem_code" }
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "flex-row-center-center no_rem_mt-12 co-#161A1D no_rem_desc" }, "请扫码关注公众号", -1)
const _hoisted_13 = { class: "flex-row-center-start no_rem_mt-21 no_rem_pb-10 co-#161A1D no_rem_desc" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "咨询电话：", -1)
const _hoisted_15 = { class: "font-blod" }

import {
		onMounted,
		ref,
		getCurrentInstance
	} from 'vue';
	
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

	const { proxy } = getCurrentInstance(); 
	const ishow = ref(0);
	const ishowCustomer = ref(false);

	onMounted(() => {
		// 获取窗口大小
		if (document.body.clientWidth > 1024) {
			proxy.$store.commit("setWebSiteType", false);
		} else {
			proxy.$store.commit("setWebSiteType", true);
		}

		// 监听窗口变化
		window.onresize = () => {
			return (() => {
				if (document.body.clientWidth > 1024) {
					proxy.$store.commit("setWebSiteType", false);
				} else {
					proxy.$store.commit("setWebSiteType", true);
				}
			})()
		};
		getPublic();
	});

	// 回到顶部
	const backTop = () => {
		document.documentElement.scrollTop = 0;
		window.pageYOffset = 0; // 兼容ios
		document.body.scrollTop = 0; // 兼容低版本ie
	};

	// 显示客服弹窗
	const showCustomer = () => {
		ishow.value = 1;
		ishowCustomer.value = !ishowCustomer.value;
		if (!ishowCustomer.value) {
			let a = setTimeout(() => {
				clearTimeout(a);
				ishow.value = 0;
			}, 1000);
		}
	};
	
	// 获取公共参数
	const getPublic = () => {
		proxy.$api.request({
			url: "/common",
			success: (res: any) => {
				proxy.$store.commit("setStoreInfo", res.data);
			}
		})
	}

return (_ctx: any,_cache: any) => {
  const _component_header_view = _resolveComponent("header-view")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_footer_view = _resolveComponent("footer-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_header_view),
    _createVNode(_component_router_view),
    _createVNode(_component_footer_view),
    (!_unref(proxy).$store.state.is_phone)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: "flex-row-center-center no_rem_wh-44 bg-862331 no_rem_boderra8 no_rem_menu_top pointer",
              onClick: showCustomer
            }, _hoisted_4),
            _createElementVNode("div", {
              class: "flex-row-center-center no_rem_wh-44 pointer",
              onClick: backTop
            }, _hoisted_6),
            (ishow.value == 1)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["absolute no_rem_customer animate__animated no_rem_plr-10", {'animate__fadeInRight': ishowCustomer.value, 'animate__fadeOutRight': !ishowCustomer.value}])
                }, [
                  _hoisted_7,
                  _hoisted_8,
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("img", {
                        class: "no_rem_code_pic",
                        src: _unref(proxy).$store.state.storeInfo.brief_customer_qr,
                        alt: ""
                      }, null, 8, _hoisted_11)
                    ])
                  ]),
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(proxy).$store.state.storeInfo.brief_phone), 1)
                  ])
                ], 2))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})